import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  algorithm: "bubble",
  color: "#35c6ff",
  speed: 100,
  range: 30,
  play: false,
  values: [],
  timeouts: [],
  updateCurrentStep: 0,
};

const visualSlice = createSlice({
  name: "updateProps",
  initialState,
  reducers: {
    updateRange: (state, action) => {
      const arr = [];
      for (let i = 0; i < action.payload; i++) {
        arr.push([Math.floor(Math.random() * 100) + 1, i]);
      }
      state.range = action.payload;
      state.values = arr;
      state.updateCurrentStep = 0;
    },

    updateValues: (state, action) => {
      state.values = action.payload;
    },

    updateSpeed: (state, action) => {
      state.speed = action.payload;
    },

    updateColor: (state, action) => {
      state.color = action.payload;
    },

    updateAlgorithm: (state, action) => {
      state.algorithm = action.payload;
      state.updateCurrentStep = 0;
    },

    updateTimeouts: (state, action) => {
      state.timeouts = action.payload;
    },

    changeValues: (state) => {
      const arr = [];
      for (let i = 0; i < state.range; i++) {
        arr.push([Math.floor(Math.random() * 100) + 1, i]);
      }
      state.values = arr;
      state.updateCurrentStep = 0;
    },

    playPause: (state, action) => {
      state.play = action.payload;
    },

    updateCurrentStep: (state, action) => {
      state.updateCurrentStep = action.payload;
    },
  },
});

export const {
  updateRange,
  updateValues,
  updateSpeed,
  updateColor,
  updateAlgorithm,
  updateTimeouts,
  changeValues,
  playPause,
  updateCurrentStep,
} = visualSlice.actions;

export default visualSlice.reducer;
